import styled from 'styled-components';
import {Menu} from 'antd';
import {bordersStyles} from '../../../../utils/styles';

const StyledVendorSelect = styled.div`
  .ant-input-affix-wrapper  > .ant-input {
    font-size: 16px;
  }
`;

const StyledVendorSelectDropdownContainer = styled.div`

`;

const StyledVendorSelectMenu = styled(Menu)`
  &.ant-dropdown-menu {
    padding-left: 0;
    padding-right: 0;
  }
`;

const StyledVendorSelectMenuItem = styled(Menu.Item)`
  .ant-dropdown-menu-title-content {
    & >.ant-space {
      & > .ant-space-item {
        display: flex;
        &:nth-of-type(1) {
          span {
            display: inline-block;
            max-width: 150px;
            width: 150px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        &:nth-of-type(2) {
          .ant-space {
            gap: 24px !important;
          }
        }
      }
    }
  }
`;

const StyledVendorDropdownContent = styled.div`
  background-color: ${props => props.theme.colors.neutral_1};
  border-radius: ${props => props.theme.border_radius.standard};
  padding: 4px;
  position: relative;
  box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08),
              0 3px 6px -4px rgba(0, 0, 0, 0.12),
              0 9px 28px 8px rgba(0, 0, 0, 0.05);

  .ant-dropdown-menu {
    box-shadow: unset;
    max-height: 250px;
    overflow: auto;
  }

  .dropdown-searched-content {
    .ant-typography {
      color: ${props => props.theme.colors.neutral_7};
      font-size: 14px;
      margin-bottom: 0;
      padding: 8px 12px;
    }

    button {
      align-items: center;
      color: ${props => props.theme.colors.primary_6};
      display: flex;
      justify-content: left;
      padding: 5px 12px;
      text-align: left;
      width: 100%;
    }
  }

  .search + .dropdown-searched-content {
    padding-top: 42px;
  }
`;

const StyledVendorSelectSearchContainer = styled.div`
  position: absolute;
  left: 4px;
  width: calc(100% - (4px * 2));
  z-index: 1;

  & > div {
    width: 100%;
    button.ant-btn {
      background-color: ${props => props.theme.colors.primary_6};
      color: ${props => props.theme.colors.neutral_1};
      font-size: 14px;

      &:not(:disabled):not(.ant-btn-disabled):hover {
        background-color: ${props => props.theme.colors.primary_5};
        border-color: ${props => props.theme.colors.primary_5};
        color: ${props => props.theme.colors.neutral_1};
      }

      &:not(:disabled):not(.ant-btn-disabled):active {
        background-color: ${props => props.theme.colors.primary_7};
        border-color: ${props => props.theme.colors.primary_7};
        color: ${props => props.theme.colors.neutral_1};
      }
      &:disabled {
        background-color: rgba(0, 0, 0, 0.04);
        color: rgba(0, 0, 0, 0.25);
      }
    }
  }

  input.ant-input {
    font-size: 14px;
  }

  .ant-input-affix-wrapper-status-error {
    border-color: #d9d9d9 !important;
  }
`;

const StyledVendorSelectInputContent = styled.div`
  ${bordersStyles.default};

  align-items: center;
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  min-height: 56px;
  padding: 5px 12px;
  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);

  &.disabled-vendor-select {
    border-color: transparent !important;

    &:hover {
      cursor: default;
    }
  }

  &:active,
  &:focus,
  &:hover {
    border-color: #1688AE;
    cursor: pointer;
  }
`;

const StyledVendorSelectInputContentValue = styled.div`
  color: ${props => props.theme.colors.neutral_10};
`;

const StyledVendorSelectInputContentValueTitle = styled.div`
  color: ${props => props.theme.colors.neutral_7};
  font-weight: 700;
  line-height: 22px;
`;

const StyledVendorSelectInputPlaceholder = styled.span`
  color: ${props => props.theme.colors.neutral_6};
  font-size: 14px;
`;

const StyledVendorSelectInputContentValueIban = styled.div`
  background-color: ${props => props.theme.colors.neutral_2};
  border-radius: ${props => props.theme.border_radius.standard};
  line-height: 22px;
  padding: 0 5px;
  word-break: break-all;
`;

export {
  StyledVendorDropdownContent,
  StyledVendorSelectDropdownContainer,
  StyledVendorSelectSearchContainer,
  StyledVendorSelect,
  StyledVendorSelectMenu,
  StyledVendorSelectMenuItem,
  StyledVendorSelectInputContent,
  StyledVendorSelectInputContentValue,
  StyledVendorSelectInputPlaceholder,
  StyledVendorSelectInputContentValueTitle,
  StyledVendorSelectInputContentValueIban
};
